export default function initProductBoilerSeriesCta() {
  const cta = document.querySelector(".js-product-boiler-series-cta");

  if (!cta) return;

  const footer = document.querySelector(".l-footer");
  const showAfterScroll = 100;

  updateVisibility();
  window.addEventListener("scroll", updateVisibility, { passive: true });
  window.addEventListener("resize", updateVisibility);

  const resizeObserver = new ResizeObserver(() => {
    if (cta.classList.contains("is-visible")) {
      syncBodyOffset();
    }
  });
  resizeObserver.observe(cta);

  function updateVisibility() {
    const shouldShow = window.scrollY > showAfterScroll && !isFooterReached();

    cta.classList.toggle("is-visible", shouldShow);
    cta.setAttribute("aria-hidden", shouldShow ? "false" : "true");

    if (shouldShow) {
      requestAnimationFrame(syncBodyOffset);
    } else {
      document.body.style.removeProperty("--p-product-boiler-series-cta-offset");
    }
  }

  function syncBodyOffset() {
    document.body.style.setProperty(
      "--p-product-boiler-series-cta-offset",
      `${cta.offsetHeight}px`,
    );
  }

  function isFooterReached() {
    if (!footer) return false;

    const footerRect = footer.getBoundingClientRect();

    return footerRect.top <= window.innerHeight;
  }
}
